@if (!inline) {
  <div class="lang-wrapper">
    <div class="dropdown">
      <button
        class="btn dropdown-toggle"
        id="dropdownMenuButton1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        >
        <img [src]="'assets/icons/flags/flag-' + currLang + '.svg'" alt="">
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        @for (lang of translateService.getLangs(); track trackLang($index, lang)) {
          <li
            >
            <img
              class="flag clickable"
              (click)="changeLang(lang)"
              [src]="'assets/icons/flags/flag-'+lang+'.svg'"
              [alt]="lang">
            </li>
          }
        </ul>
      </div>
    </div>
  }

  @if (inline) {
    <div class="lang-wrapper">
      @for (lang of translateService.getLangs(); track trackLang($index, lang)) {
        <img
          class="flag"
          (click)="changeLang(lang)"
          [src]="'assets/icons/flags/flag-'+lang+'.svg'"
          [alt]="lang">
        }
      </div>
    }
